// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headingStages":"oXPZS","sectionTitle":"_7jhlV","stages":"_2r1Lq","stagesDot":"Rwi7F"};